import type {
  InsuranceOffer,
  InsuranceOfferWithSelectedState,
} from '@backmarket/http-api'

import { DEFAULT_INSURANCE_ID } from '../constants'

export function hasOfferCompliancyError(
  insuranceOffer: InsuranceOfferWithSelectedState,
) {
  return (
    insuranceOffer.selected &&
    insuranceOffer.compliancy.isUserAgreementRequired &&
    !insuranceOffer.compliancy.isUserAgreementAccepted
  )
}

export function isDefaultOfferSelected(
  insuranceOffer: InsuranceOfferWithSelectedState,
) {
  return (
    insuranceOffer.id.toString() === DEFAULT_INSURANCE_ID &&
    insuranceOffer.selected
  )
}

export function hasInsuranceSelected(
  insuranceOffers: InsuranceOfferWithSelectedState[],
) {
  return !insuranceOffers.some(isDefaultOfferSelected)
}

export function getOfferWithoutSelectedState(
  insuranceOffer?: InsuranceOfferWithSelectedState,
): InsuranceOffer | null {
  if (insuranceOffer) {
    const { selected, ...offerWithoutSelectedState } = insuranceOffer

    return offerWithoutSelectedState
  }

  return null
}
